import React, { Component } from "react"
import { translate } from "react-translate"
import { Segment } from "semantic-ui-react"
import "./ConditionDevis.css"

class ConditionDevis extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    let { t } = this.props

    return (
      <Segment id="divCondition">
        <p id="indication">{t("label_edition_condition_devis_indication")}</p>
        <Segment id="signatureClient">
          {t("label_edition_condition_devis_signature_client")} Signature du
          client
          <Segment id="cadreSignature" />
        </Segment>
        <Segment id="signatureFournisseur">
          {t("label_edition_condition_devis_signature_fournisseur")}
          Signature du fournisseur
          <Segment id="cadreSignature" />
        </Segment>

        <Segment id="informationFin">
          <hr />
          {t("label_edition_condition_devis_information")}
        </Segment>
      </Segment>
    )
  }
}

export default translate("ProConditionDevis")(ConditionDevis)



// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/ConditionDevis.js